var _defs, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoCuriexplore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 221.01 42.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{isolation:isolate;}.b{fill:#0a3e6c;}.c{fill:#006ec7;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M991.92,168.35c-.51-2.06-1.77-3.54-4.19-3.54-3.25,0-4.87,2.67-4.87,6.72s1.59,6.8,4.87,6.8a4,4,0,0,0,4.12-3.22l5.16.74c-.87,4.16-4.36,7-9.28,7-6.31,0-10.16-4.69-10.16-11.32s3.9-11.2,10.15-11.2c4.95,0,8.53,2.84,9.33,7.25Z",
    transform: "translate(-977.57 -150.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1014,160.62h5.53v21.82h-5.17v-2.57h-.23a7.34,7.34,0,0,1-6,2.85c-3.54,0-7.24-2.27-7.24-8.39V160.62h5.51v13.55c0,2.6,1.56,4,3.65,4,2.47,0,4-2.06,4-5.46Z",
    transform: "translate(-977.57 -150.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1036.28,165.82a4.71,4.71,0,0,0-2-.46,4.62,4.62,0,0,0-4.45,4.7v12.38h-5.51V160.62h5.4v3.09h.31a5,5,0,0,1,5-3.39,6.49,6.49,0,0,1,3,.71Z",
    transform: "translate(-977.57 -150.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1040.74,155.87a3.06,3.06,0,0,1,3.17-2.92,2.93,2.93,0,1,1,0,5.85A3,3,0,0,1,1040.74,155.87Zm5.91,26.57h-5.51V160.62h5.51Z",
    transform: "translate(-977.57 -150.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1050.6,171.81c0-6.66,3.81-11.48,10.34-11.48,5.54,0,9.76,3.48,9.76,10.49v2.31h-14.77c.35,3.24,2.06,5.2,5.2,5.2a4.25,4.25,0,0,0,4.4-3l4.94,1.33c-.79,3-3.63,6.21-9.3,6.21C1054.62,182.85,1050.6,178.63,1050.6,171.81Zm5.48-2.47h9.39a4.29,4.29,0,0,0-4.57-4.53C1058.37,164.81,1056.67,166.47,1056.08,169.34Z",
    transform: "translate(-977.57 -150.98)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1103.78,189a2.39,2.39,0,0,1-1.11,2,4.14,4.14,0,0,1-2.43.78q-4.68,0-15-15.78l-1.44,2.52q-1.74,2.88-5.22,8.82-.72,1.5-2.22,4.44a3,3,0,0,1-2.76,1.68q-4.5,0-4.5-2,0-1.44,2.88-4.62.9-1,5.61-8t4.71-7.47q0-.54-5.28-7.74t-5.28-8.88a2.85,2.85,0,0,1,.93-2.22,3.4,3.4,0,0,1,2.37-.84,5.87,5.87,0,0,1,4.86,2.89,27.11,27.11,0,0,1,3.09,6.15,33.75,33.75,0,0,0,2.55,5.54,104.77,104.77,0,0,0,7-11.33q2-4,4.38-4a2.44,2.44,0,0,1,2,1,4.05,4.05,0,0,1,.9,2.22l-11.22,17.1q2.28,4,5.7,8.94,4.86,7.08,6.24,7.08a6.81,6.81,0,0,0,1-.09,6.66,6.66,0,0,1,.9-.09Q1103.78,187.1,1103.78,189Z",
    transform: "translate(-977.57 -150.98)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1106.37,160.62h5.44v2.7h.33a5.62,5.62,0,0,1,5.34-3c4.73,0,8.69,3.84,8.69,11.21s-3.8,11.28-8.68,11.28a5.62,5.62,0,0,1-5.35-3h-.26v10.77h-5.51Zm9.66,4.19c-3.35,0-4.66,2.87-4.66,6.72s1.28,6.8,4.66,6.8,4.9-2.73,4.9-6.8S1119.28,164.81,1116,164.81Z",
    transform: "translate(-977.57 -150.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1135.63,182.44h-5.51v-29.1h5.51Z",
    transform: "translate(-977.57 -150.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1139.58,171.57c0-6.68,3.91-11.24,10.16-11.24s10.15,4.56,10.15,11.24-3.89,11.28-10.15,11.28S1139.58,178.2,1139.58,171.57Zm15,0c0-3.88-1.42-6.76-4.87-6.76s-4.88,2.88-4.88,6.76,1.44,6.76,4.88,6.76S1154.61,175.43,1154.61,171.57Z",
    transform: "translate(-977.57 -150.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1175.69,165.82a4.75,4.75,0,0,0-2-.46,4.61,4.61,0,0,0-4.45,4.7v12.38h-5.51V160.62h5.4v3.09h.31a5,5,0,0,1,5-3.39,6.52,6.52,0,0,1,3,.71Z",
    transform: "translate(-977.57 -150.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1178.49,171.81c0-6.66,3.8-11.48,10.34-11.48,5.54,0,9.76,3.48,9.76,10.49v2.31h-14.78c.36,3.24,2.06,5.2,5.2,5.2a4.26,4.26,0,0,0,4.41-3l4.94,1.33c-.8,3-3.64,6.21-9.3,6.21C1182.51,182.85,1178.49,178.63,1178.49,171.81Zm5.48-2.47h9.39a4.3,4.3,0,0,0-4.57-4.53C1186.26,164.81,1184.55,166.47,1184,169.34Z",
    transform: "translate(-977.57 -150.98)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCuriexplore);
export default __webpack_public_path__ + "static/media/logo-curiexplore.d1b81ac3eafbc17ba5c078f671f2e865.svg";
export { ForwardRef as ReactComponent };